import "core-js/modules/es.array.concat.js";
import { zonedTimeToUtc } from 'date-fns-tz';

/**
 * Converts a date string, time string, and IANA timezone into a UTC ISO string.
 * @param {string} date - Date in YYYY-MM-DD format
 * @param {string} time - Time in HH:MM:SS format
 * @param {string} timezone - IANA timezone name, e.g. 'Europe/London'
 * @returns {string} UTC ISO 8601 string
 */
export default function getUtcDateTime(date, time, timezone) {
  return zonedTimeToUtc("".concat(date, " ").concat(time), timezone).toISOString();
}